import { UploadFileDetailsDragDropType } from './UploadFileTypes';
import React, { memo, useEffect, useState } from 'react';
import { ColourMod, FlexAlign } from '../../../Data/Enums/LayoutEnums';
import StackHorizontal from '../../Wrappers/StackHorizontal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import StackVertical from '../../Wrappers/StackVertical';
import Button from '../../Buttons/Button';
import { faCopy, faEye, faGripLines, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { GetReadableFileSize } from '../../../Constants/Helpers';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';

const UploadFileEntryDragDrop = memo((props: UploadFileDetailsDragDropType) => {
	const [showPreview, setShowPreview] = useState<boolean>(false);

	useEffect(() => {
		setShowPreview(false);
	}, [props.isDragging]);

	return (
		<>
			<div
				className={`upload-file-entry upload-file-entry-d-d ${!props.valid ? ColourMod.Alert : ''} ${
					showPreview ? 'upload-preview-active' : ''
				}`}
				aria-label={`${props.file.name} File Entry`}
			>
				<StackHorizontal>
					<div className={'p-sm'}>
						<FontAwesomeIcon icon={faGripLines} />
					</div>
					<Button
						squared
						colour={showPreview ? ColourMod.Primary : ColourMod.Text}
						onClick={() => setShowPreview(!showPreview)}
						title={'Preview'}
						extraClass={'m-0'}
					>
						<FontAwesomeIcon icon={faEye} />
					</Button>
				</StackHorizontal>
				<StackVertical align={FlexAlign.Start}>
					<div className={'upload-file-entry-name'}>{props.file.name}</div>
					<span className={'upload-file-entry-size'}>{GetReadableFileSize(props.file.size)}</span>
				</StackVertical>
				<div className={'upload-file-entry-actions'}>
					<div className={`upload-file-entry-action upload-file-entry-valid`}>
						{props.valid && <FontAwesomeIcon icon={faCheck} />}
					</div>
				</div>
				<Button
					title={`Duplicate ${props.file.name}`}
					icon={<FontAwesomeIcon icon={faCopy} fixedWidth={true} />}
					iconOnly
					onClick={() => props.duplicateCallback()}
					extraClass={`upload-file-entry-action upload-file-entry-remove`}
					colour={ColourMod.Secondary}
				/>
				<Button
					title={`Remove ${props.file.name}`}
					icon={<FontAwesomeIcon icon={faTrash} fixedWidth={true} />}
					iconOnly
					onClick={() => props.removeCallback()}
					extraClass={`upload-file-entry-action upload-file-entry-remove`}
					colour={ColourMod.Alert}
				/>
			</div>
			{showPreview && (
				<div className={`upload-file-preview`}>
					<embed src={URL.createObjectURL(props.file)} />
				</div>
			)}
		</>
	);
});

export { UploadFileEntryDragDrop };
